import { useI18n } from '../i18n';

interface PaymentMethodPickerProps {
  selected: 'cash' | 'card';
  onChange: (method: 'cash' | 'card') => void;
}

export function PaymentMethodPicker({ selected, onChange }: PaymentMethodPickerProps) {
  const { t } = useI18n();
  return (
    <div className="hc-payment-methods">
      <div className="hc-payment-method-options">
        <button
          type="button"
          className={`hc-payment-method-btn ${selected === 'cash' ? 'hc-selected' : ''}`}
          onClick={() => onChange('cash')}
        >
          {t('checkout.paymentCash')}
        </button>
        <button
          type="button"
          className={`hc-payment-method-btn ${selected === 'card' ? 'hc-selected' : ''}`}
          onClick={() => onChange('card')}
        >
          {t('checkout.paymentCard')}
        </button>
      </div>
    </div>
  );
}
